var magicStyles = [".message[data-v-340ebc8b]{font-size:1rem;color:var(--magic-dark,#000);text-align:center;margin-bottom:var(--magic-space--small,8px)}.resend[data-v-340ebc8b]{display:flex;align-items:center;justify-content:center;gap:var(--magic-space--small,8px)}"];

export default magicStyles;
